export default class UserInput {
    constructor() {
        /**
         * @private
         * @type {boolean}
         */
        this.firstMovement = true;
        /**
         * @private
         * @type {boolean}
         */
        this.leftMouseDown = false;
        /**
         * @private
         * @type {number}
         */
        this.prevMouseX = 0;
        /**
         * @private
         * @type {number}
         */
        this.prevMouseY = 0;
        /**
         * @type {number}
         */
        this.mouseX = 0;
        /**
         * @type {number}
         */
        this.mouseY = 0;
        /**
         * @private
         * @type {number}
         */
        this.mouseDeltaX = 0;
        /**
         * @private
         * @type {number}
         */
        this.mouseDeltaY = 0;
        /**
         * @private
         * @type {number}
         */
        this.mouseDownTime = 0;

        /**
         * @private
         * @type {number}
         */
        this.mouseDownX = 0;
        /**
         * @private
         * @type {number}
         */
        this.mouseDownY = 0;

        /**
         * @type {boolean}
         */
        this.leftMouseClick = false;
        /**
         * @type {number}
         */
        this.clickX = 0;
        /**
         * @type {number}
         */
        this.clickY = 0;

        // /**
        //  * @private
        //  * @type {Object.<number, boolean>}
        //  */
        // this.keysPressed = {};

        /**
         * @private
         * @type {number}
         */
        this.mouseWheelMotion = 0;
        /**
         * @private
         * @type {boolean}
         */
        this.mouseMoved = false;
    }

    /**
     * @param {Document} document The page document. We listen to the document for keyboard events.
     * @param {HTMLElement} element The page element. We listen to the element for mouse events.
     */
    attachListeners(document, element) {
        const thisRef = this;

        // element.onkeydown = function (event) {
        //     //console.log('onkeydown code=' + event.code + ' key=' + event.key);
        //     thisRef.keysPressed[event.code] = true;
        // };
    
        // element.onkeyup = function (event) {
        //     //console.log('onkeyup code=' + event.code + ' key=' + event.key);
        //     thisRef.keysPressed[event.code] = false;
        // };
    
        // the canvas needs focus (and a tabindex attribute) in order to receive keyboard events.
        element.onmouseover = function (event) {
            element.focus();

            thisRef.mouseX = event.clientX;
            thisRef.mouseY = event.clientY;
            return false;
        };

        // If the mouse leaves the canvas, then we need to believe that the buttons are no longer pressed.
        // Otherwise we end up with stuck keys.
        element.onmouseout = function(event) {
            thisRef.leftMouseDown = false;

            thisRef.mouseX = event.clientX;
            thisRef.mouseY = event.clientY;
            thisRef.firstMovement = true;
        }

        if (document) {
            document.onmouseout = function(event) {
                thisRef.leftMouseDown = false;

                thisRef.mouseX = event.clientX;
                thisRef.mouseY = event.clientY;
                thisRef.firstMovement = true;
            }
        }

        // Note: element.onclick does not do what we want. we want mouse click events to happen only
        // if the mouse has not moved. onclick is fired every time the mouse is released.

        // mouse wheel support for IE9, Chrome, Safari and Opera
        element.addEventListener("mousewheel", function(event) {
            // Annoyingly, the mouse wheel values in Chrome are opposite of what they are in Firefox.
            // A rotation of 1 in FF would be -1 in Chrome.
            thisRef.mouseWheelMotion = -(event.wheelDelta || event.detail);
            return false;
        }, false);

        // mouse wheel support for firefox
        element.addEventListener("DOMMouseScroll", function(event) {
            thisRef.mouseWheelMotion = (event.wheelDelta || event.detail);
            return false;
        }, false);


        element.onmousedown = function(event) {
            thisRef.mouseX = event.clientX;
            thisRef.mouseY = event.clientY;
            
            // update the position of the mouse
            thisRef.prevMouseX = event.clientX;
            thisRef.prevMouseY = event.clientY;

            thisRef.mouseMoved = false;

            // initialize for mouse drag and mouse click
            thisRef.mouseDeltaX = 0;
            thisRef.mouseDeltaY = 0;

            thisRef.mouseDownX = event.clientX;
            thisRef.mouseDownY = event.clientY;
            thisRef.mouseDownTime = Date.now();

            // The left mouse button is either 0 or 1 depending on the browser.
            if (event.button === 0 || event.button === 1) {
                thisRef.leftMouseDown = true;
            }
            return false;
        }

        element.onmouseup = function(event) {
            // update the position of the mouse
            thisRef.mouseX = event.clientX;
            thisRef.mouseY = event.clientY;

            thisRef.mouseDeltaX = thisRef.mouseX - thisRef.prevMouseX;
            thisRef.mouseDeltaY = thisRef.mouseY - thisRef.prevMouseY;

            thisRef.prevMouseX = thisRef.mouseX;
            thisRef.prevMouseY = thisRef.mouseY;

            // The left mouse button is either 0 or 1 depending on the browser.
            if (event.button === 0 || event.button === 1) {
                thisRef.leftMouseDown = false;

                const deltaX = thisRef.mouseX - thisRef.mouseDownX;
                const deltaY = thisRef.mouseY - thisRef.mouseDownY;

                // If the down/up time was fast, and if the mouse didn't move, then we consider it a click.
                if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5 && (Date.now() - thisRef.mouseDownTime < 250)) {

                    thisRef.leftMouseClick = true;
                    thisRef.clickX = event.clientX;
                    thisRef.clickY = event.clientY;
                }
            }
            return false;
        }

        element.onmousemove = function(event) {
            thisRef.onMouseMove(event.clientX, event.clientY);
            return false;
        }
    }

    /**
     * 
     * @param {number} mouseX
     * @param {number} mouseY 
     */
    onMouseMove(mouseX, mouseY) {
        this.mouseX = mouseX;
        this.mouseY = mouseY;

        this.mouseMoved = true;

        // Check for special case where this is the first time the mouse has moved.
        // At this point, we do not have a previous xy, so do not calculate the delta.
        if (this.firstMovement) {
            // First movement gets set back to true every time the mouse leaves the window.
            this.firstMovement = false;
        }
        else {
            // This event can be invoked multiple times per frame, so we need to accumulate the
            // deltas.
            this.mouseDeltaX += this.mouseX - this.prevMouseX;
            this.mouseDeltaY += this.mouseY - this.prevMouseY;
        }

        this.prevMouseX = this.mouseX;
        this.prevMouseY = this.mouseY;
    }

    // /**
    //  * @param {Array.<String>} keyCodeArray 
    //  * @returns {boolean}
    //  */
    // isKeyPressed(keyCodeArray) {
    //     for (var i = 0; i < keyCodeArray.length; i++) {
    //         if (this.keysPressed[keyCodeArray[i]]) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }

    /**
     * Resets the per-frame input state. Things that have to be for each frame.
     */
    resetInputState() {
        this.leftMouseClick = false;
        this.mouseWheelMotion = 0;
        this.mouseDeltaX = 0;
        this.mouseDeltaY = 0;
        this.mouseMoved = false;
    }
    
}